const appliedIndexKeys = {
  all: ['appliedIndex'],
  allByEntity: (entityId: string) => [appliedIndexKeys.all, entityId]
};

export default appliedIndexKeys;
